module.exports = __webpack_public_path__ + "media/images/area/feature/banner/pc/zh-hans_shikoku-fb38729670b5e01259a79c3a80fb7600.jpg";